import { useCallback } from "react"

export interface BannerTrackingConfig {
  clickUrl?: string
  impressionHtml?: any[]
  vendorScriptSrc?: string
  vendorNoscriptHtml?: string
}

export const useBannerTracking = () => {
  const trackClick = useCallback(async (trackingConfig?: BannerTrackingConfig, bannerUrl?: string) => {
    if (trackingConfig?.clickUrl) {
      await fetch(trackingConfig.clickUrl, {
        method: 'GET',
        mode: 'no-cors',
        cache: 'no-cache'
      }).catch(() => {})
    }

    if (bannerUrl) {
      setTimeout(() => {
        window.location.href = bannerUrl
      }, 200)
    }
  }, [])

  const getImpressionTrackingData = useCallback((trackingConfig?: BannerTrackingConfig) => {
    if (!trackingConfig) return null

    return {
      impressionHtml: trackingConfig.impressionHtml,
      vendorScriptSrc: trackingConfig.vendorScriptSrc,
      vendorNoscriptHtml: trackingConfig.vendorNoscriptHtml,
    }
  }, [])

  return {
    trackClick,
    getImpressionTrackingData,
  }
}
